import {
  Contract,
  formatUnits,
  parseUnits,
  ethers,
  formatEther,
  BrowserProvider,
   providers,JsonRpcProvider 
} from "ethers";
import {
  TOKEN_CONTRACT_ADDRESS,
  PRESALE_CONTRACT_ADDRESS,
  USDT_CONTRACT_ADDRESS,
  USDC_CONTRACT_ADDRESS,
  TOKEN_ABI,
  PRESALE_ABI,
  STAKING_CONTRACT_ADDRESS,
  STAKING_ABI

  
  
} from "../contracts/contracts";
// File: useSaveUserData.js
import { useEffect, useState, useRef } from "react";

import {
  useAppKitAccount,
  useAppKitNetwork,
  useAppKitProvider,
} from "@reown/appkit/react";
// import { useAccount, useBalance, useChainId } from "wagmi";
// import { useEthersSigner } from "./useEtherSigner";

// Define the two networks (BSC and Matic)
// Define the two networks (BSC and Matic)
const NETWORKS = {
  56: {
    // Binance Smart Chain (BSC) Mainnet
    PRESALE_CONTRACT_ADDRESS: "0x0ac016Cd0F4f5F481A95fa09279a7b4F2713B264",
    USDT_CONTRACT_ADDRESS: "0x55d398326f99059fF775485246999027B3197955",
    USDC_CONTRACT_ADDRESS: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
    TOKEN_CONTRACT_ADDRESS: "0x93761858DA901e5195e4b2D933D16e9cB7EF9b7C",
    decimals: 18,
  },
  8453: {
    // Base Network
    PRESALE_CONTRACT_ADDRESS: "0x243048D7C2229029E46eA800C0a37f751B7a6805",
    USDT_CONTRACT_ADDRESS: "0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2",
    USDC_CONTRACT_ADDRESS: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
    TOKEN_CONTRACT_ADDRESS: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
    decimals: 6,
  },
  1: {
    // Ethereum Mainnet
    PRESALE_CONTRACT_ADDRESS: "0xFACA9A111664Bc8A912bA704C93b19F38a2d3fFB",
    USDT_CONTRACT_ADDRESS: "0xdac17f958d2ee523a2206206994597c13d831ec7",
    USDC_CONTRACT_ADDRESS: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
    TOKEN_CONTRACT_ADDRESS: "0x243048D7C2229029E46eA800C0a37f751B7a6805",
    decimals: 6,
  },
};
function useContract() {
  const { isConnected, address } = useAppKitAccount();
  const { chainId } = useAppKitNetwork();
  const { walletProvider } = useAppKitProvider("eip155");

  const getAppkitBalance = async (address) => {
    if (!walletProvider) return 0;
    const provider = new BrowserProvider(walletProvider, chainId);
    const balance = await provider.getBalance(address);
    return formatEther(balance);
  };

  const getProvider = async () => {
    if (!walletProvider || !chainId) return null;
    return new BrowserProvider(walletProvider, chainId);
  };

  const getSigner = async () => {
    if (!walletProvider || !chainId || !isConnected) return null;
    try {
      const provider = new BrowserProvider(walletProvider, chainId);
      const signer = await provider.getSigner();
      return signer;
    } catch (error) {
      console.error("Error getting signer:", error);
      return null;
    }
  };

  const getNetworkConfig = async () => {
    if (NETWORKS[chainId]) {
      const {
        PRESALE_CONTRACT_ADDRESS,
        USDT_CONTRACT_ADDRESS,
        USDC_CONTRACT_ADDRESS,
        TOKEN_CONTRACT_ADDRESS, // Include TOKEN_CONTRACT_ADDRESS here
        decimals,
      } = NETWORKS[chainId];
      return {
        chainId,
        PRESALE_CONTRACT_ADDRESS,
        USDT_CONTRACT_ADDRESS,
        USDC_CONTRACT_ADDRESS,
        TOKEN_CONTRACT_ADDRESS,
        decimals,
      };
    } else {
      throw new Error("Unsupported network.");
    }
  };

  const getContract = async (address, abi) => {
    const signer = await getSigner();
    const contract = new Contract(address, abi, signer);
    return contract;
  };


const truncateDecimals = (value, maxDecimals = 18) => {
  if (!value || isNaN(value)) return "0";
  const [intPart, decimalPart] = value.toString().split(".");
  if (!decimalPart) return value;
  return `${intPart}.${decimalPart.slice(0, maxDecimals)}`;
};

const buy = async (
  paymentType,
  amount,
  referrer = "0x0000000000000000000000000000000000000000"
) => {
  try {
    // Fetch config for current network
    const {
      PRESALE_CONTRACT_ADDRESS,
      USDT_CONTRACT_ADDRESS,
      USDC_CONTRACT_ADDRESS,
      decimals,
    } = await getNetworkConfig();

    // Init Presale contract
    const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI);

    if (
      paymentType === "ETH" ||
      paymentType === "ETH(Base)" ||
      paymentType === "BNB" ||
      paymentType === "POL"
    ) {
      try {
        const formattedAmount = truncateDecimals(amount.toString(), 18);
        const transaction = await contract.buyFromNative(referrer, {
          value: parseUnits(formattedAmount, 18),
        });
        const receipt = await transaction.wait();
        return receipt;
      } catch (error) {
        console.error("Native token purchase error:", {
          error,
          message: error.message,
          code: error.code,
          data: error.data,
          transaction: error.transaction,
        });
        throw error;
      }
    } else if (paymentType === "USDT") {
      const usdt = await getContract(USDT_CONTRACT_ADDRESS, TOKEN_ABI);
      const formattedAmount = truncateDecimals(amount.toString(), decimals);

      // Approve
      const approveTx = await usdt.approve(
        PRESALE_CONTRACT_ADDRESS,
        parseUnits(formattedAmount, decimals)
      );
      await approveTx.wait();

      // Buy with referral
      const buyTx = await contract.buyFromToken(
        referrer,
        1,
        parseUnits(formattedAmount, decimals)
      ); // 1 = USDT
      const receipt = await buyTx.wait();
      return receipt;
    } else if (paymentType === "USDC") {
      const usdc = await getContract(USDC_CONTRACT_ADDRESS, TOKEN_ABI);
      const formattedAmount = truncateDecimals(amount.toString(), decimals);

      // Approve
      const approveTx = await usdc.approve(
        PRESALE_CONTRACT_ADDRESS,
        parseUnits(formattedAmount, decimals)
      );
      await approveTx.wait();

      // Buy with referral
      const buyTx = await contract.buyFromToken(
        referrer,
        2,
        parseUnits(formattedAmount, decimals)
      ); // 2 = USDC
      const receipt = await buyTx.wait();
      return receipt;
    } else {
      throw new Error("Unsupported payment type");
    }
  } catch (error) {
    console.error("Error during purchase:", error);
    throw error;
  }
};





 

  // Constants
  const BSC_CLAIM_CONTRACT_ADDRESS = "0x93e9f3092D59a3639A6eE16B60bc82f2F3BEB959";
  const BSC_MAINNET_CHAIN_ID_HEX = "0x38"; // 56 in hex
  const BSC_MAINNET_CHAIN_ID_DEC = 56;
  





    const getProviders1 = () => {
    if (walletProvider) {
      return new BrowserProvider(walletProvider);
    } else {
      // Use a public provider for read-only operations
      return new ethers.JsonRpcProvider("https://rpc.ankr.com/eth/be9a41869c1ad6c0d6318698e56698043f082c055680e5eb4f9a163a68f0449e");
    }
  };
  


  const getPresaleAllocation = async () => {
    const signer = await getSigner();
    if (!isConnected || !signer) {
      return 0;
    }
    try {
      // Get the provider and network information
      if (signer) {
        // Ensure we're connected to the correct network
        const networkConfig = NETWORKS[chainId];
        if (!networkConfig) {
          throw new Error("Unsupported network.");
        }
        const { PRESALE_CONTRACT_ADDRESS } = networkConfig; // Get the contract address for the current network
        // Get the contract instance
        const contract = await getContract(
          PRESALE_CONTRACT_ADDRESS,
          PRESALE_ABI
        );
        // Fetch the unclaimed tokens for the user
        const unclaimedTokens = await contract.getPresaleUnclaimed(address);
        const formattedUnclaimedTokens = formatUnits(unclaimedTokens, 18); // Format the tokens
        return formattedUnclaimedTokens;
      }
      return null;
    } catch (error) {
      // Handle any errors that may occur during the process
      console.error(
        "Error fetching presale allocation:",
        error.message || error
      );
    }
  };

  const getData = async () => {
    // Check if the wallet is connected
    const signer = await getSigner();
    if (!isConnected || !signer) {
      return { balanceInEth: 0, contractBalance: 0 }; // Return default values if not connected
    }
    try {
      // Get the provider and network information
      if (signer) {
        // Ensure we're connected to the correct network
        const { chain_id } = await getNetworkConfig(); // Get the correct chainId from the network config
        if (chainId !== chain_id) {
          throw new Error("Connected to the wrong network.");
        }
        // Fetch the appropriate contract address based on the network
        const { PRESALE_CONTRACT_ADDRESS, TOKEN_CONTRACT_ADDRESS } =
          await getNetworkConfig();
        // Get the token contract instance
        const token = await getContract(TOKEN_CONTRACT_ADDRESS, TOKEN_ABI);
        // Fetch the user's token balance
        const balance = await token.balanceOf(address);
        const balanceInEth = formatUnits(balance, 18); // Format the user's balance
        // Fetch the contract's token balance
        const contractBalanceInEth = await token.balanceOf(
          PRESALE_CONTRACT_ADDRESS
        );
        const contractBalance = formatUnits(contractBalanceInEth, 18); // Format the contract's balance
        return {
          balanceInEth,
          contractBalance,
        };
      }
      return { balanceInEth: 0, contractBalance: 0 };
    } catch (error) {
      // Handle any errors that may occur during the process
      console.error("Error fetching data:", error.message || error);
    }
  };

  // Get user's token balance
  const myTokenBalance = async () => {
    const signer = await getSigner();
    if (!isConnected || !signer) return 0;
    const { TOKEN_CONTRACT_ADDRESS } = await getNetworkConfig();
    const token = await getContract(TOKEN_CONTRACT_ADDRESS, TOKEN_ABI, signer);
    const balance = await token.balanceOf(address);
    return formatUnits(balance, 18);
  };

  const maxBalances = async () => {
    try {
      const signer = await getSigner();
      if (!isConnected || !signer) {
        return { usdt: "0.0000", usdc: "0.0000", eth: "0.0000", bnb: "0.0000" };
      }
      // Fetch the current network configuration
      const networkConfig = await getNetworkConfig();
      const { USDT_CONTRACT_ADDRESS, USDC_CONTRACT_ADDRESS } = networkConfig;
      if (!USDT_CONTRACT_ADDRESS || !USDC_CONTRACT_ADDRESS) {
        throw new Error(
          "USDT or USDC contract address not found for this network."
        );
      }
      // Get contract instances
      const usdt = await getContract(USDT_CONTRACT_ADDRESS, TOKEN_ABI, signer);
      const usdc = await getContract(USDC_CONTRACT_ADDRESS, TOKEN_ABI, signer);
      // Fetch balances
      const balance = await getAppkitBalance(address);
      const [usdtBalance, usdcBalance, ethBalance, bnbBalance] =
        await Promise.all([
          usdt.balanceOf(address),
          usdc.balanceOf(address),
          balance,
          balance,
        ]);
      // Return formatted balances
      return {
        usdt: formatUnits(usdtBalance, 6), // USDT typically has 6 decimals
        usdc: formatUnits(usdcBalance, 6), // USDC typically has 6 decimals
        eth: ethBalance, // ETH typically has 18 decimals
        bnb: bnbBalance, // BNB also has 18 decimals
      };
    } catch (error) {
      console.error("Error fetching balances:", error);
      return { usdt: "0.0000", usdc: "0.0000", eth: "0.0000", bnb: "0.0000" };
    }
  };



  const BSC_RPC = "https://rpc.ankr.com/eth/510d3bbfa1a8923d003ee483a94d7bd005daf4fab8319ee17debba00a6fbab3f";




// Create a single BSC RPC provider
const bscProvider = new JsonRpcProvider(BSC_RPC);

const getPrice = async () => {
  try {
    const contract = new Contract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, bscProvider);
    const price = await contract.perDollarPrice();
    return Number(formatUnits(price, 18)).toFixed(4);
  } catch (error) {
    console.error("Error fetching price from BSC:", error.message || error);
    return "0.0000";
  }
};



  // const getTotalTokensSoldAcrossNetworks = async () => {
  //   try {
  //     let totalTokens = 0;
  //     for (const networkId of Object.keys(NETWORKS)) {
  //       const provider = new ethers.JsonRpcProvider(
  //         "https://rpc.ankr.com/base"
  //       ); // Replace with relevant RPC URL
  //       const { PRESALE_CONTRACT_ADDRESS } = NETWORKS[networkId];
  //       const contract = new Contract(
  //         PRESALE_CONTRACT_ADDRESS,
  //         PRESALE_ABI,
  //         provider
  //       );
  //       const tokensSold = await contract.totalTokensSold();
  //       totalTokens += parseFloat(ethers.formatUnits(tokensSold, 18)); // Convert to decimal
  //     }
  //     return totalTokens.toFixed(2); // Return formatted value
  //   } catch (error) {
  //     console.error("Error fetching total tokens sold:", error);
  //     return "Error";
  //   }
  // };










    // Helper: Get user's token_balance on the current network
    const getUserTokenBalance = async () => {
      if (!isConnected || !address) return "0";
      try {
        const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig();
        const provider = new BrowserProvider(walletProvider, chainId);
        const contract = new Contract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, provider);
        const userInfo = await contract.users(address);
        return userInfo.token_balance?.toString() ?? "0";
      } catch (e) {
        console.error("Error fetching user token balance:", e);
        return "0";
      }
    };



// === NETWORK CONFIGURATION (without BSC) ===
const NETWORK_CONFIG = [
  {
    name: "Ethereum",
    chainId: 1,
    rpc: "https://rpc.ankr.com/eth/510d3bbfa1a8923d003ee483a94d7bd005daf4fab8319ee17debba00a6fbab3f",
    presaleContract: "0xFACA9A111664Bc8A912bA704C93b19F38a2d3fFB",
  },
  {
    name: "Base",
    chainId: 8453,
    rpc: "https://rpc.ankr.com/base/be9a41869c1ad6c0d6318698e56698043f082c055680e5eb4f9a163a68f0449e",
    presaleContract: "0x243048D7C2229029E46eA800C0a37f751B7a6805",
  },
];

// === BSC CONFIGURATION ===
const BSC_CONFIG = {
  name: "BSC",
  chainId: 56,
  rpc: "https://rpc.ankr.com/bsc/be9a41869c1ad6c0d6318698e56698043f082c055680e5eb4f9a163a68f0449e",
  presaleContract: "0x0ac016Cd0F4f5F481A95fa09279a7b4F2713B264",
};




const OTHER_NETWORKS = [
  {
    name: "Base",
    key: "base",
    chainId: 8453,
    rpc: "https://rpc.ankr.com/base/510d3bbfa1a8923d003ee483a94d7bd005daf4fab8319ee17debba00a6fbab3f",
    presaleContract: "0x243048D7C2229029E46eA800C0a37f751B7a6805",
  },
  {
    name: "BSC",
    chainId: 56,
    rpc: "https://rpc.ankr.com/bsc/510d3bbfa1a8923d003ee483a94d7bd005daf4fab8319ee17debba00a6fbab3f",
    presaleContract: "0x0ac016cd0f4f5f481a95fa09279a7b4f2713b264",
  },
];





const ETH_CONFIG = {
  name: "Ethereum",
  key: "ethereum",
  chainId: 1,
  rpc: "https://rpc.ankr.com/eth/510d3bbfa1a8923d003ee483a94d7bd005daf4fab8319ee17debba00a6fbab3f",
  presaleContract: "0xFACA9A111664Bc8A912bA704C93b19F38a2d3fFB",
};





 const getUserPresaleBalances = async (userAddress) => {
  if (!userAddress) return null;

  let ethereumBalance = "0";
  let summedOthersBalance = 0;

  // --- ETH balance ---
  try {
    const ethProvider = new JsonRpcProvider(ETH_CONFIG.rpc);
    const ethContract = new Contract(ETH_CONFIG.presaleContract, PRESALE_ABI, ethProvider);
    const ethUser = await ethContract.users(userAddress);
    const ethRaw = ethUser.token_balance?.toString() || "0";
    ethereumBalance = parseFloat(formatUnits(ethRaw, 18)).toFixed(4);
  } catch (err) {
    console.error("[Ethereum] Error:", err.message);
    ethereumBalance = "0.0000";
  }

  // --- Other networks sum ---
  await Promise.all(
    OTHER_NETWORKS.map(async (net) => {
      try {
        const provider = new JsonRpcProvider(net.rpc);
        const contract = new Contract(net.presaleContract, PRESALE_ABI, provider);
        const user = await contract.users(userAddress);
        const raw = user.token_balance?.toString() || "0";
        const formatted = parseFloat(formatUnits(raw, 18));
        summedOthersBalance += formatted;
      } catch (err) {
        console.error(`[${net.name}] Error:`, err.message);
      }
    })
  );

  return {
    ethereum: ethereumBalance,
    others: summedOthersBalance.toFixed(4)
  };
};






// Sum token_balance for all networks except BSC
const getUserTokenBalanceWithoutBsc = async (address) => {
  if (!address) return "0";
  let total = 0;
  for (const net of NETWORK_CONFIG) {
    try {
      const provider = new JsonRpcProvider(net.rpc, net.chainId);
      const contract = new Contract(net.presaleContract, PRESALE_ABI, provider);
      const userInfo = await contract.users(address);
      // Convert from wei (18 decimals) to integer tokens (no decimals)
      const tokenBalance = userInfo.token_balance?.toString() || "0";
      // Divide by 1e18 and remove decimals
      total += Math.floor(Number(tokenBalance) / 1e18);
    } catch (e) {
      console.error(`[${net.name}] Error fetching user token balance:`, e);
    }
  }
  return total.toString();
};



// Get token_balance on BSC only
// Get token_balance on BSC only, removing 18 decimals
const getUserBscTokenBalance = async (address) => {
  if (!address) return "0";
  try {
    const provider = new JsonRpcProvider(BSC_CONFIG.rpc, BSC_CONFIG.chainId);
    const contract = new Contract(BSC_CONFIG.presaleContract, PRESALE_ABI, provider);
    const userInfo = await contract.users(address);
    const tokenBalance = userInfo.token_balance?.toString() || "0";
    // Convert from wei to integer tokens (no decimals)
    const integerBalance = Math.floor(Number(tokenBalance) / 1e18);
    return integerBalance.toString();
  } catch (e) {
    console.error("[BSC] Error fetching user token balance:", e);
    return "0";
  }
};









  const getUserVestingInfo = async () => {
    if (!isConnected || !walletProvider) {
      console.log("Wallet is not connected");
      return null;
    }
  
    try {
      const provider = new ethers.BrowserProvider(walletProvider);
      const signer = await provider.getSigner();
  
      const address = await signer.getAddress();
  
      const contract = new ethers.Contract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);
  
      console.log("Fetching vesting info for address:", address);
  
      const vestingInfo = await contract.getUserVestingInfo(address);
  
      const {
        totalVested,
        released,
        claimable,
        startTime,
        cliffEndTime,
        vestingEndTime,
      } = {
        totalVested: vestingInfo[0],
        released: vestingInfo[1],
        claimable: vestingInfo[2],
        startTime: vestingInfo[3],
        cliffEndTime: vestingInfo[4],
        vestingEndTime: vestingInfo[5],
      };
  
      console.log("Raw vesting data:", {
        totalVested,
        released,
        claimable,
        startTime,
        cliffEndTime,
        vestingEndTime,
      });
  
      // Format vesting values (assume 18 decimals for tokens)
      const formattedVesting = {
        totalVested: ethers.formatUnits(totalVested, 18),
        released: ethers.formatUnits(released, 18),
        claimable: ethers.formatUnits(claimable, 18),
        startTime: Number(startTime),
        cliffEndTime: Number(cliffEndTime),
        vestingEndTime: Number(vestingEndTime),
      };
  
      console.log("Formatted vesting info:", formattedVesting);
  
      return formattedVesting;
  
    } catch (err) {
      console.error("Error fetching vesting info:", err);
      return null;
    }
  };
  

const manualvestTokens = async (amount) => {
  try {
    const provider = getProvider();
    if (!provider) {
      console.log("Wallet not connected");
      return;
    }

    const signer = await getSigner(provider);

    // Vesting contract instance
    const vestingContract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);

    // Parse amount with 18 decimals
    const parsedAmount = ethers.parseUnits(amount.toString(), 18);

    // Call the vest function on the vesting contract directly (assumes approval already exists)
    const vestTx = await vestingContract.vestToken(parsedAmount);
    console.log("Vesting initiated, waiting for confirmation...");
    const receipt = await vestTx.wait();
    console.log("Vesting successful:", receipt);

    return receipt;
  } catch (error) {
    console.error("Error during vesting:", error);
  }
};

  


    const getCliffEndTime = async () => {
    try {
      if (!isConnected) return 0;
  
      const provider = getProvider();
      const chainId = await provider.getNetwork();
  
   const { chain_id } = await getNetworkConfig(); // Get the correct chainId from the network config
        if (chainId !== chain_id) {
          throw new Error("Connected to the wrong network.");
        }
      const signer = await getSigner(provider);
      const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);
  
      // Destructure to get cliffEndTime (index 4)
      const [,,, , cliffEndTime] = await contract.getUserVestingInfo(address);
  
      return Number(cliffEndTime.toString()); // Convert BigNumber to number
    } catch (error) {
      console.error("Error fetching cliff time:", error);
      return 0;
    }
  };
  

const getVestedClaimed = async () => {
  if (!isConnected || !address) return "0";

  try {
    const networkConfig = NETWORKS[chainId];
    if (!networkConfig) throw new Error("Unsupported network.");

    const { PRESALE_CONTRACT_ADDRESS, decimals = 18 } = networkConfig;

    const signer = await getSigner();
    if (!signer) throw new Error("Signer not available");

    const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);

    const claimedTokens = await contract.getVestedClaimed(address);
    return formatUnits(claimedTokens, decimals);
  } catch (error) {
    console.error("Error fetching vested claimed tokens:", error.message || error);
    return "0";
  }
};




  
const getVestedAllocation = async () => {
  if (!isConnected || !address) return "0";

  try {
    const networkConfig = NETWORKS[chainId];
    if (!networkConfig) throw new Error("Unsupported network.");

    const { PRESALE_CONTRACT_ADDRESS, decimals = 18 } = networkConfig;

    const signer = await getSigner();
    if (!signer) throw new Error("Signer not available");

    const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);

    const vestedTokens = await contract.vestedAllocations(address);
    return formatUnits(vestedTokens, decimals);
  } catch (error) {
    console.error("Error fetching vested allocation:", error.message || error);
    return "0";
  }
};



const getVestedClaimable = async () => {
  if (!isConnected || !address) return "0";

  try {
    const networkConfig = NETWORKS[chainId];
    if (!networkConfig) throw new Error("Unsupported network.");

    const { PRESALE_CONTRACT_ADDRESS, decimals = 18 } = networkConfig;

    const signer = await getSigner();
    if (!signer) throw new Error("Signer not available");

    const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);

    const claimableTokens = await contract.getVestedUnclaimed(address);
    return formatUnits(claimableTokens, decimals);
  } catch (error) {
    console.error("Error fetching vested claimable tokens:", error.message || error);
    return "0";
  }
};







  const getPresaleContract = async () => {
    if (!isConnected || !address) return null;
  
    const provider = getProvider();
    const network = await provider.getNetwork();
  
     const { chain_id } = await getNetworkConfig(); // Get the correct chainId from the network config
        if (chainId !== chain_id) {
          throw new Error("Connected to the wrong network.");
        }
    const contract = new ethers.Contract(
      PRESALE_CONTRACT_ADDRESS,
      PRESALE_ABI,
      provider // no signer needed for view-only calls
    );
  
    return contract;
  };






  const getTotalUsers = async () => {
    try {
      const provider = getProviders1(); // Use a provider without a wallet connection
      const contract = new Contract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, provider);
      const totalUsers = await contract.totalUsers();
      return totalUsers.toNumber(); // Convert BigNumber to regular number
    } catch (error) {
      console.error("Error fetching total users:", error.message);
      throw error;
    }
  };


   const vestTokens = async () => {
    console.log(claimTokens);

    const provider = getProvider();
    const signer = await getSigner(provider);
    // print singer address
    const contract = await getContract(
      PRESALE_CONTRACT_ADDRESS,
      PRESALE_ABI,
      signer
    );
    const transaction = await contract.buyAndVest(

   
    );
    const receipt = await transaction.wait();
    return receipt;
  };




    const claimvestTokens = async () => {
    console.log(claimTokens);

    const provider = getProvider();
    const signer = await getSigner(provider);
    // print singer address
    const contract = await getContract(
      PRESALE_CONTRACT_ADDRESS,
      PRESALE_ABI,
      signer
    );
    const transaction = await contract.claimVestedTokens(

   
    );
    const receipt = await transaction.wait();
    return receipt;
  };



  const buyAndTokens = async () => {
    console.log(buyAndTokens);

    const provider = getProvider();
    const signer = await getSigner(provider);
    // print singer address
    const contract = await getContract(
      PRESALE_CONTRACT_ADDRESS,
      PRESALE_ABI,
      signer
    );
    const transaction = await contract.buyAndVest(

   
    );
    const receipt = await transaction.wait();
    return receipt;
  };



const claimTokens = async ({ amount = 0, proof = [] } = {}) => {
  const walletProvider = window.ethereum;

  if (!walletProvider) {
    throw new Error("Wallet provider not found. Please connect your wallet.");
  }

  // ✅ 1. Ensure wallet is on Ethereum Mainnet
  try {
    await walletProvider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // Ethereum Mainnet
    });
  } catch (err) {
    if (err.code === 4902) {
      throw new Error("Ethereum network not added to your wallet.");
    } else {
      throw new Error("Please switch to Ethereum Mainnet in your wallet.");
    }
  }

  // ✅ 2. Continue with claim on Ethereum
  const provider = getProvider();
  const signer = await getSigner(provider);
      const contract = new Contract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);

  try {
    const tx = await contract.claimTokens(amount, proof);
    const receipt = await tx.wait();
    return receipt;
  } catch (err) {
    console.error("Claim failed:", err);
    throw err;
  }
};




  const getReferralCount = async (userAddress) => {
  if (!userAddress || !isConnected || !chainId) return "0";

  try {
    const networkConfig = NETWORKS[chainId];
    if (!networkConfig) throw new Error("Unsupported network.");

    const { PRESALE_CONTRACT_ADDRESS } = networkConfig;

    const signer = await getSigner();
    if (!signer) throw new Error("Signer not available");

    const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);

    const count = await contract.referralCounts(userAddress);
    return count.toString(); // or use formatUnits if it's in token units
  } catch (error) {
    console.error("Error fetching referral count:", error.message || error);
    return "0";
  }
};



const getReferralRewards = async () => {
  if (!isConnected || !address) return "0";

  try {
    const networkConfig = NETWORKS[chainId];
    if (!networkConfig) throw new Error("Unsupported network.");

    const { PRESALE_CONTRACT_ADDRESS, decimals = 18 } = networkConfig;

    const signer = await getSigner();
    if (!signer) throw new Error("Signer not available");

    const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);

    const referralTokens = await contract.getTotalReferralTokens(address);
    return parseFloat(formatUnits(referralTokens, decimals)).toFixed(4); // Show 4 decimals
  } catch (error) {
    console.error("Error fetching referral rewards:", error.message || error);
    return "0.0000";
  }
};

    const claimRefTokens = async () => {
    console.log(claimTokens);

    const provider = getProvider();
    const signer = await getSigner(provider);
    // print singer address
    const contract = await getContract(
      PRESALE_CONTRACT_ADDRESS,
      PRESALE_ABI,
      signer
    );
    const transaction = await contract.claimReferralRewards(

   
    );
    const receipt = await transaction.wait();
    return receipt;
  };



  ////Staking logic


    const stakeTokens = async (amount , lockupIndex) => {
    if (!walletProvider || !isConnected) return;
  
    const provider = getProvider(); // Get the provider
    const signer = await getSigner(provider);
  
    // Get the token contract and staking contract
    const token = await getContract(TOKEN_CONTRACT_ADDRESS, TOKEN_ABI, signer);
    const stakingContract = await getContract(STAKING_CONTRACT_ADDRESS, STAKING_ABI, signer);
  
    // Parse the amount to the correct decimals (assuming 18 decimals for the token)
    const decimals = 18;
    const parsedAmount = ethers.parseUnits(amount.toString(), decimals);
  
    try {
      // Step 1: Approve the staking contract to spend the user's tokens
      const approvalTx = await token.approve(STAKING_CONTRACT_ADDRESS, parsedAmount);
      await approvalTx.wait(); // Wait for the approval transaction to be confirmed
      console.log("Token approval successful");
  
  
      const stakeTx = await stakingContract.stake(parsedAmount, lockupIndex);
      await stakeTx.wait(); // Wait for the staking transaction to be confirmed
      console.log("Tokens staked successfully");
  
      return stakeTx.hash;
    } catch (error) {
      console.error("Error in staking tokens:", error.message || error);
      throw error;
    }
  };






    const getStakeinfo = async () => {
    if (!isConnected || !address) return null;
  
    try {
      const provider = new ethers.JsonRpcProvider(
        "https://bsc-dataseed.binance.org/"
      );
  
      const stakingContract = new Contract(
        STAKING_CONTRACT_ADDRESS,
        STAKING_ABI,
        provider
      );
  
      const stakeCount = await stakingContract.getStakeCount(address);
      const stakeCountNum = Number(stakeCount);
      if (stakeCountNum === 0) {
        console.log("User has no stakes");
        return [];
      }
  
      const [
        indices,
        amounts,
        startTimes,
        endTimes,
        lockupIndexes,
        withdrawn,
        rewards,
      ] = await stakingContract.getUserStakeDetails(address);
  
      const totalStakes = amounts.length;
  
      const formattedData = Array.from({ length: totalStakes }, (_, i) => ({
        index: indices[i],
        amount: Number(formatUnits(amounts[i], 18)).toFixed(2),
        reward: Number(formatUnits(rewards[i], 18)).toFixed(6),
        lockupIndex: Number(lockupIndexes[i]),
        startTime: new Date(Number(startTimes[i]) * 1000).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit'
        }),
        endTime: new Date(Number(endTimes[i]) * 1000).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit'
        }),
        endTimeUnix: Number(endTimes[i]), // raw Unix timestamp in seconds
        
        withdrawn: withdrawn[i],
        stakeId: `${lockupIndexes[i]}-${startTimes[i]}-${amounts[i]}`,
      }));
  
      return formattedData;
    } catch (error) {
      console.error("❌ Error fetching stake data:", error);
      return null;
    }
  };
  



  const getTotalClaimedRewards = async () => {
  if (!isConnected || !address) return "0";

  try {
     if (!walletProvider || !isConnected) return;
  
    const provider = getProvider(); // Get the provider
    const signer = await getSigner(provider);
  
    // Get the token contract and staking contract
    const token = await getContract(TOKEN_CONTRACT_ADDRESS, TOKEN_ABI, signer);
    const stakingContract = await getContract(STAKING_CONTRACT_ADDRESS, STAKING_ABI, signer);
  

    if (!signer) throw new Error("Signer not available");

    const contract = await getContract(STAKING_CONTRACT_ADDRESS, STAKING_ABI, signer);

    const referralTokens = await contract.getUserTotalClaimedRewards(address);
    return parseFloat(formatUnits(referralTokens)).toFixed(4); // Show 4 decimals
  } catch (error) {
    console.error("Error fetching referral rewards:", error.message || error);
    return "0.0000";
  }
};





  const getTotalUnclaimedReward = async () => {
  if (!isConnected || !address) return "0";

  try {
    if (!walletProvider || !isConnected) return;
  
    const provider = getProvider(); // Get the provider
    const signer = await getSigner(provider);
  
    // Get the token contract and staking contract
    const token = await getContract(TOKEN_CONTRACT_ADDRESS, TOKEN_ABI, signer);
    const stakingContract = await getContract(STAKING_CONTRACT_ADDRESS, STAKING_ABI, signer);
  

    if (!signer) throw new Error("Signer not available");

    const contract = await getContract(STAKING_CONTRACT_ADDRESS, STAKING_ABI, signer);

    const referralTokens = await contract.getUserTotalUnclaimedReward(address);
    return parseFloat(formatUnits(referralTokens)).toFixed(4); // Show 4 decimals
  } catch (error) {
    console.error("Error fetching referral rewards:", error.message || error);
    return "0.0000";
  }
};




      const claimStakingTokens = async () => {
    console.log(claimTokens);

    const provider = getProvider();
    const signer = await getSigner(provider);
    // print singer address
    const contract = await getContract(
      STAKING_CONTRACT_ADDRESS,
      STAKING_ABI,
      signer
    );
    const transaction = await contract.claimAllRewards(

   
    );
    const receipt = await transaction.wait();
    return receipt;
  };







const useSaveUserData = () => {
  const [user, setUser] = useState(null);
  const lastSavedDataRef = useRef({});

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const saveUserData = async ({
    address,
    isConnected,
    balance,
    totalStaked,
    referralCount,
    referralReward,
    totalClaimedRewards,
    totalUnclaimedReward,
    referrer, // NEW
  }) => {
    if (!address || !isConnected || !user) return;

    const currentData = {
      wallet_address: address,
      full_name: user?.full_name || "",
      email: user?.email || "",
      username: user?.username || "",
      phone: user?.phone || "",
      balance,
      total_staked: totalStaked,
      referral_count: referralCount,
      referral_reward: referralReward,
      total_claimed: totalClaimedRewards,
      total_unclaimed: totalUnclaimedReward,
      referrer: referrer || "", // NEW
    };

    const lastSaved = lastSavedDataRef.current;
    const hasChanges = Object.keys(currentData).some(
      (key) => currentData[key] !== lastSaved[key]
    );

    if (!hasChanges) return;

    try {
      await fetch(`${API_URL}/save-profile-data.php`,
       {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(currentData),
      });

      lastSavedDataRef.current = currentData;
    } catch (err) {
      console.error("Error saving user data:", err);
    }
  };

  return { saveUserData };
};




const getReferrerOf = async () => {
  if (!isConnected || !address || !walletProvider) return null;

  try {
    const provider = getProvider();
    const signer = await getSigner(provider);

    const stakingContract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);

    const referrer = await stakingContract.referrerOf(address);

    return referrer;
  } catch (error) {
    console.error("Error fetching referrer:", error.message || error);
    return null;
  }
};

const API_URL = process.env.REACT_APP_API_URL;

const saveVestingData = async ({
  address,
  vestedAllocated,
  vestedClaimed,
  vestedClaimable,
  vestedLocked,
}) => {
  try {
   await fetch(`${API_URL}/save-vesting-data.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        wallet_address: address,
        vested_allocated: vestedAllocated,
        vested_claimed: vestedClaimed,
        vested_claimable: vestedClaimable,
        vested_locked: vestedLocked,
      }),
    });
  } catch (err) {
    console.error("Failed to save vesting data:", err);
  }
};






const transferTokens = async ({ to, amount }) => {
  const walletProvider = window.ethereum;

  if (!walletProvider) {
    throw new Error("Wallet provider not found. Please connect your wallet.");
  }

  // ✅ 1. Ensure wallet is on Ethereum Mainnet
  try {
    await walletProvider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // Ethereum Mainnet
    });
  } catch (err) {
    if (err.code === 4902) {
      throw new Error("Ethereum network not added to your wallet.");
    } else {
      throw new Error("Please switch to Ethereum Mainnet in your wallet.");
    }
  }

  // ✅ 2. Setup provider and signer
  const provider = new ethers.BrowserProvider(walletProvider); // for ethers v6
  const signer = await provider.getSigner();

  const contract = new ethers.Contract(TOKEN_CONTRACT_ADDRESS, TOKEN_ABI, signer);

  try {
    // ✅ 3. Send transfer transaction
    const tx = await contract.transfer(to, amount); // amount must be in token decimals
    const receipt = await tx.wait();

    console.log("Transfer successful:", receipt);
    return receipt;
  } catch (err) {
    console.error("Transfer failed:", err);
    throw err;
  }
};



const checkAllowance = async (owner, amount) => {
  if (!owner || !amount) return false;

  try {
    // Use your BSC rpc provider here
    const tokenContract = new Contract(TOKEN_CONTRACT_ADDRESS, TOKEN_ABI, bscProvider);

    const allowance = await tokenContract.allowance(owner, PRESALE_CONTRACT_ADDRESS);

    const decimals = 18; // adjust as per your token decimals
    const needed = ethers.parseUnits(amount.toString(), decimals);

    return allowance >= needed;
  } catch (e) {
    console.error("checkAllowance (BSC) error:", e);
    return false;
  }
};


// Approve PRESALE_CONTRACT_ADDRESS to spend `amount` tokens on user's behalf
const approveTokens = async (amount) => {
  if (!isConnected || !address) throw new Error("Wallet not connected");
  try {
    // Get network-specific config (token address/decimals)
    const { TOKEN_CONTRACT_ADDRESS, PRESALE_CONTRACT_ADDRESS} = await getNetworkConfig();
    const signer = await getSigner();



      // Parse the amount to the correct decimals (assuming 18 decimals for the token)
    const decimals = 18;
    const parsedAmount = ethers.parseUnits(amount.toString(), decimals);
  


    const tokenContract = await getContract(TOKEN_CONTRACT_ADDRESS, TOKEN_ABI, signer);



    const tx = await tokenContract.approve(PRESALE_CONTRACT_ADDRESS, parsedAmount);
    await tx.wait();

    return true;
  } catch (err) {
    console.error("Approval failed:", err);
    throw err;
  }
};



  return {
    getAppkitBalance,
    getProvider,
    getSigner,
    buy,
    getData,
    myTokenBalance,
    maxBalances,
    getPrice,
    getPresaleAllocation,

    getUserTokenBalanceWithoutBsc,
    getUserBscTokenBalance,
    getUserVestingInfo,
    manualvestTokens,
    getCliffEndTime,
    getVestedClaimed,
    getPresaleContract,
    getVestedAllocation,
    getTotalUsers,
    vestTokens,
claimvestTokens,
buyAndTokens,
claimTokens,
getReferralCount,


getProviders1,
getVestedClaimable,
getReferralRewards,
claimRefTokens,


stakeTokens,
getStakeinfo,
getTotalClaimedRewards,
claimStakingTokens,
getTotalUnclaimedReward,
useSaveUserData,
getReferrerOf,
saveVestingData,
getUserPresaleBalances,
transferTokens,
 approveTokens,
 checkAllowance



  };
}

export default useContract;
